/* "Fil Instagram" section: seamless looping strip (auto-scroll + drag/swipe)
   and the Instagram-style card opened from a photo. See sections/ig-feed.liquid. */
(function () {
  function init(root) {
    if (root.dataset.igInit) return;
    root.dataset.igInit = '1';

    var track = root.querySelector('[data-ig-track]');
    var modal = root.querySelector('[data-ig-modal]');
    var posts = root.querySelector('[data-ig-posts]');
    if (!track || !modal || !posts) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var autoplay = root.dataset.autoplay === 'true';
    var pxPerSecond = (parseInt(root.dataset.speed, 10) || 3) * 12;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var groupWidth = 0;
    var pos = 0;
    var lastInteraction = 0;
    var visible = true;
    var hovering = false;
    var modalOpen = false;
    var selfScroll = false;
    var userActive = false; // finger down on the strip
    var wrapTimer;

    /* --- Looping: [group][group][group], always kept inside the middle one --- */
    function build() {
      Array.prototype.slice.call(track.children).forEach(function (el) {
        if (!el.hasAttribute('data-ig-original')) el.remove();
      });
      originals.forEach(function (el) {
        el.setAttribute('data-ig-original', '');
      });

      var slideWidth = originals[0].getBoundingClientRect().width || 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var setWidth = originals.length * (slideWidth + gap);
      var repeats = Math.max(1, Math.ceil((track.clientWidth + slideWidth) / setWidth));

      // Extra copies of the originals so one group is always wider than the viewport.
      var firstGroup = originals.slice();
      for (var k = 1; k < repeats; k++) {
        originals.forEach(function (el) {
          firstGroup.push(makeClone(el));
        });
      }
      firstGroup.forEach(function (el) {
        if (el.parentNode !== track) track.appendChild(el);
      });

      for (var g = 0; g < 2; g++) {
        firstGroup.forEach(function (el) {
          track.appendChild(makeClone(el));
        });
      }

      groupWidth = (slideWidth + gap) * firstGroup.length;
      pos = groupWidth + (pos % groupWidth || 0);
      setScroll(pos);
    }

    function makeClone(el) {
      var clone = el.cloneNode(true);
      clone.removeAttribute('data-ig-original');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('button').forEach(function (b) {
        b.tabIndex = -1;
      });
      return clone;
    }

    function setScroll(value) {
      selfScroll = true;
      track.scrollLeft = value;
      requestAnimationFrame(function () {
        selfScroll = false;
      });
    }

    function wrap() {
      if (!groupWidth) return;
      if (pos >= groupWidth * 2) {
        pos -= groupWidth;
        setScroll(pos);
      } else if (pos < groupWidth) {
        pos += groupWidth;
        setScroll(pos);
      }
    }

    // Manual scrolling (swipe, trackpad, wheel): the strip follows the finger and
    // the auto-scroll waits. The loop jump is done once the scrolling settles so
    // it doesn't cut the swipe momentum short.
    track.addEventListener('scroll', function () {
      if (selfScroll && !userActive) return;
      pos = track.scrollLeft;
      lastInteraction = performance.now();
      if (groupWidth && (pos < 2 || pos > groupWidth * 3 - track.clientWidth - 2)) {
        wrap();
        return;
      }
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(wrap, 150);
    });

    function touchStart() {
      userActive = true;
      pos = track.scrollLeft;
    }

    function touchEnd() {
      userActive = false;
      lastInteraction = performance.now();
    }

    track.addEventListener('touchstart', touchStart, { passive: true });
    track.addEventListener('touchend', touchEnd, { passive: true });
    track.addEventListener('touchcancel', touchEnd, { passive: true });

    /* --- Auto-scroll --- */
    var last = 0;
    function tick(now) {
      var dt = last ? Math.min(now - last, 64) : 0;
      last = now;
      var idle = now - lastInteraction > 2500;
      if (autoplay && !reduceMotion && visible && !hovering && !modalOpen && idle && !dragging && !userActive) {
        pos += (pxPerSecond * dt) / 1000;
        wrap();
        setScroll(pos);
      }
      requestAnimationFrame(tick);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }).observe(root);
    }

    track.addEventListener('mouseenter', function () {
      hovering = true;
    });
    track.addEventListener('mouseleave', function () {
      hovering = false;
    });

    /* --- Mouse drag (touch uses native scrolling) --- */
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startPos = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startPos = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) {
        pos = startPos - dx;
        wrap();
        setScroll(pos);
      }
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      lastInteraction = performance.now();
      track.classList.remove('is-dragging');
    });

    /* --- Pop-up card --- */
    var cardMedia = modal.querySelector('[data-ig-card-media]');
    var cardLikes = modal.querySelector('[data-ig-card-likes]');
    var cardDate = modal.querySelector('[data-ig-card-date]');
    var cardProducts = modal.querySelector('[data-ig-card-products]');
    var cardChips = modal.querySelector('[data-ig-card-chips]');
    var closeButton = modal.querySelector('.ig-feed__close');
    var opener = null;

    function openPost(index, trigger) {
      var template = posts.querySelector('[data-ig-post="' + index + '"]');
      if (!template) return;
      var content = template.content.cloneNode(true);

      cardMedia.innerHTML = '';
      cardMedia.appendChild(content.querySelector('[data-ig-media]').firstElementChild || document.createTextNode(''));
      cardLikes.textContent = template.dataset.likes || '';
      cardDate.textContent = template.dataset.date || '';

      var chips = content.querySelector('[data-ig-chips]');
      cardChips.innerHTML = '';
      var hasChips = chips && chips.children.length > 0;
      if (hasChips) {
        while (chips.firstChild) cardChips.appendChild(chips.firstChild);
      }
      cardProducts.hidden = !hasChips;

      opener = trigger;
      modalOpen = true;
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      document.body.classList.add('ig-feed-modal-open');
      closeButton.focus();
    }

    function closePost() {
      if (modal.hidden) return;
      modal.hidden = true;
      modalOpen = false;
      document.body.classList.remove('ig-feed-modal-open');
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    }

    track.addEventListener('click', function (e) {
      if (moved) {
        moved = false;
        e.preventDefault();
        return;
      }
      var button = e.target.closest('[data-ig-open]');
      if (!button) return;
      var slide = button.closest('[data-ig-index]');
      if (slide) openPost(slide.dataset.igIndex, button);
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ig-close]')) closePost();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePost();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });

    build();
    requestAnimationFrame(tick);
    // Slides can change size once images are decoded.
    window.addEventListener('load', build);
  }

  function initAll() {
    document.querySelectorAll('[data-ig-feed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
